module.exports = __webpack_public_path__ + "static/media/lepetitpaumeLogo.5cd7db7e.jpg";